import ToastMessage from 'react-native-toast-message';
import { CustomToastProps } from './Toast.types';

export const Toast = {
  show: ({
    type = 'success',
    title,
    text,
    autoHide = true,
    position,
    bottomOffset,
    onShow,
    onHide,
    onPress,
    props,
  }: CustomToastProps) => {
    ToastMessage.show({
      type,
      text1: title,
      text2: text,
      autoHide,
      position,
      bottomOffset,
      onShow,
      onHide,
      onPress,
      props,
    });
  },
  hide: () => ToastMessage.hide(),
};
